import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { TeemappService } from '@teem/services/teemapp.service';
import { LoaderService } from '@teem/services/loader.service';

import { messages as i18n } from '@teem/constants/messages';
import { PLAN_TYPES, PLAN_PRICES } from '@teem/constants/subscription';
import { MixpanelService } from '@teem/services/mixpanel.service';


import { CardDetailModalComponent } from '@teem/setting-module/modals/card-detail-modal/card-detail-modal.component';

@Component({
  selector: 'subscription-plan-form',
  templateUrl: './subscription-plan-form.component.html',
  styleUrls: ['./subscription-plan-form.component.css']
})
export class SubscriptionPlanFormComponent implements OnInit {
  @Output() onSubscribePlan: EventEmitter<any> = new EventEmitter();
  @Input() planType: any;
  @Input() planFrequency: any;
  @Input() planAmount: number;
  @Input() userDetails: any;
  @Input() subscriptionBtn: any;

  planCurrency: string = $localize`:@@currency.sar:SAR`;
  activePlan: any;
  changePlanLabel: string;
  promoCodeForm: FormGroup;
  couponDetail: any;
  submitted: boolean = false;
  planTypes: any = PLAN_TYPES;
  planPrices: any = PLAN_PRICES;
  defaultCouponType: 'percentage';
  showSelectPlan: boolean = true;
  showSubscriptionInProgress: boolean = false;
  userProperties: any;

  @Input('activePlan')
  set setActivePlan(value: any) {
    this.activePlan = value;

    setTimeout(() => {
      this.showHideSelectPlanButton();
    })

  }

  @Input('userDetails')
  set setUserDetails(value: any) {
    this.userDetails = value;

    this.addCouponDetails();
  }

  constructor(
  	private fb: FormBuilder,
    private modalService: NgbModal,
    private teemappService: TeemappService,
    private mixpanelService: MixpanelService,
  	private loaderService: LoaderService) { }

  ngOnInit(): void {
  	this.promoCodeForm = this.fb.group({
      coupon_code: ['', Validators.required],
  		is_freelance: [false, ]
		});

    // this is duplicate function, this can be remove if want to remove duplicate one.
    this.addCouponDetails();
  }

  addCouponDetails() {
    if(this.userDetails && this.userDetails.has_freelancer_id && this.userDetails.freelance_discount) {
      let planFinalPrice = (this.planAmount - this.planAmount * this.userDetails.freelance_discount/100).toFixed(2);
      this.couponDetail = {
        freelance_document_id: true,
        discount_message: `${planFinalPrice} ${this.planCurrency}`  /// ${this.planFrequency}
      }
    } else if(this.userDetails?.promo_code?.coupon_code) {
      let planFinalPrice = (this.planAmount - this.planAmount * this.userDetails.promo_code.percentage/100).toFixed(2);
      this.couponDetail = {
        coupon_code: this.userDetails.promo_code.coupon_code,
        coupon_value: this.userDetails.promo_code.type,
        coupon_type: this.userDetails.promo_code.type,
        freelance_document_id: false,
        discount_message: `${planFinalPrice} ${this.planCurrency}` 
      }
    }
  }

  showHideSelectPlanButton() {
    if(this.activePlan && this.activePlan.pending_request) {
        this.showSelectPlan = false;
        if(this.activePlan.pending_request.subscription_plan == this.planType &&
          this.activePlan.pending_request.plan_frequency == this.planFrequency) {
          this.showSubscriptionInProgress = true;
        }
    } else {
      this.showSelectPlan = true;
    }
  }

  isCurrentPlan() {
    return this.activePlan && this.activePlan.subscription_plan == this.planType && this.activePlan.plan_frequency == this.planFrequency;
  }

  isCurrentPlanFrequency() {
    return this.activePlan && this.activePlan.plan_frequency == this.planFrequency;
  }

  downgradePlan() {

    if(this.activePlan.is_cancelled) {
      Swal.fire({
        title: i18n.setting.resume_subscription_to_upgrade_plan,
        confirmButtonText:i18n.ok,
        icon: 'warning'
      })
      return;
    }

    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.setting.downgrade_plan_confirm,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.cancel
    }).then( result => {
      if(result.value){
        this.selectDowngradePlan(null, 'downgrade')
      }
    });
  }

  upgradePlan() {
    

    // if((this.activePlan.payment_by == 'payfort' && this.activePlan.card_type == 'MADA') || this.activePlan.payment_by == 'apple-pay') {
    //   Swal.fire({
    //     text: i18n.setting.you_cannot_upgrade_package,
    //     confirmButtonText:i18n.ok,
    //     icon: 'info'
    //   })
    //   return;
    // }

    if(this.activePlan.is_cancelled) {
      Swal.fire({
        title: i18n.setting.resume_subscription_to_upgrade_plan,
        confirmButtonText:i18n.ok,
        icon: 'info'
      })
      return;
    }

    this.selectPlan(null, 'upgrade')

    // Swal.fire({
    //   title: i18n.setting.based_outside_saudi_arabia,
    //   text: i18n.setting.upgrade_plan_confirm,
    //   showCloseButton: true,
    //   showCancelButton: true,
    //   focusConfirm: false,
    //   confirmButtonText:
    //     i18n.setting.i_am_based_in_saudi_arabia,
    //   cancelButtonText:
    //     i18n.cancel
    // }).then( result => {
    //   if(result.value){
    //     this.selectPlan(null, 'upgrade')
    //   }
    // });
  }

  submitPromocode(){
  	this.submitted = true;

  	if(this.promoCodeForm.valid) {

  		let fd = {
  			coupon_code: this.promoCodeForm.value.coupon_code,
  			is_freelance: this.promoCodeForm.value.is_freelance,
        subscription_plan: this.planType,
        plan_frequency: this.planFrequency,
				// subscription_plan: `${this.planType}-${this.planFrequency}`,
        coupon_type: this.defaultCouponType
  		}
  		this.loaderService.startLoading();

  		this.teemappService.verifyPromocode(fd).subscribe((data:any) => {
  			this.loaderService.stopLoading();

  			if(data.status == 'valid') {
  				this.couponDetail = data.validPromocode;
  			} else if(data.msg) {
  				this.promoCodeForm.get('coupon_code').setErrors({
            serverError: data.msg
          });
  			}
  		}, err => {
  			this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
  		});

  	}
  }

  cancelPromocode() {
  	this.couponDetail = null;
  }

  selectPlan(params?:any, $requestType?:string) {
    // if(this.activePlan && !this.activePlan.is_manual && this.activePlan.plan_frequency && this.activePlan.plan_frequency !== this.planFrequency) {
    //   Swal.fire('', i18n.t('error.unable_to_select_plan'), 'warning')
    //   return;
    // }

    // Mixpanel event settings_plans_click
    let subscriptionProperties = {
      plan: this?.planType,
      plan_name: this?.planType +' '+ this?.planFrequency,
      plan_frequency: this?.planFrequency,
      price: this.planPrices[this?.planFrequency][this?.planType] +' '+ this?.planCurrency, // this?.planAmount +' '+ this?.planCurrency,
    }
    this.userProperties = this.mixpanelService.getUserProperties(this.userDetails);
    let trackProperties = this.mixpanelService.getTrackProperties(this.userDetails);
    this.mixpanelService.setUserProperties(this.userProperties);
    // merge the user and subscription properties.
    let mergedProperties = {
      ...this.userProperties,  // Assuming userDetails is an object with user details
      ...subscriptionProperties,
      ...trackProperties
    };
    this.mixpanelService.track('settings_plans_click', mergedProperties);
    if (this.userDetails?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.userDetails.billing_experimente_data.name })
    }

    Swal.fire({
      title: 'Select Payment Option',
      input: 'radio',
      inputOptions: {
        'VISA': 'VISA',
        'MASTERCARD': 'Mastercard',
        'MADA': 'MADA'
      },
      inputPlaceholder: 'Select Option',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (!value) {
            resolve('You must have to select a Payment option');
          } else {
            resolve(); // This means validation passed
          }
        });
      }
      // inputValidator: function (value) {
      //   return new Promise(function (resolve, reject) {
      //     if (!value) {
      //       resolve('You must have to select a Payment option');
      //     } else {
      //       reject();
      //     }
      //   });
      // }
    }).then((result) => {
      if (result.isConfirmed) {
        let fd:any = params ? params : {};
        if(this.couponDetail) {
          fd.couponDetail = this.couponDetail;
        }
        fd.subscription_plan = this.planType;
        fd.plan_frequency = this.planFrequency;
        fd.payment_option = result.value ? result.value : '';

        this.loaderService.startLoading();

        this.teemappService.changePlan(fd).subscribe((data:any) => {
          this.loaderService.stopLoading();

          // let msg:string = i18n.t('setting.subscription_request_submitted');
          // if($requestType == 'upgrade') {
          //   msg = i18n.t('setting.subscription_upgrade_submitted');
          // } else
          if($requestType == 'downgrade') {
            let msg:string = i18n.t('setting.subscription_downgrade_submitted');
            Swal.fire(i18n.alert.done, msg, 'success').then(() => {
              this.onSubscribePlan.emit(data);
            });
          } else {
            if(data.payment_link) {
              window.location.href = data.payment_link;
            } else {
              Swal.fire(i18n.alert.error, i18n.something_went_wrong, 'error').then(() => {
                this.onSubscribePlan.emit(data);
              });
            }
          }
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.warning, i18n.getError(err), 'warning');
        })
      }
    });

  }

  selectDowngradePlan(params?:any, $requestType?:string) {

    let fd:any = params ? params : {};
    if(this.couponDetail) {
      fd.couponDetail = this.couponDetail;
    }
    fd.subscription_plan = this.planType;
    fd.plan_frequency = this.planFrequency;

    this.loaderService.startLoading();

    this.teemappService.changePlan(fd).subscribe((data:any) => {
      this.loaderService.stopLoading();
      let msg:string = i18n.t('setting.subscription_downgrade_submitted');
      Swal.fire(i18n.alert.done, msg, 'success').then(() => {
        this.onSubscribePlan.emit(data);
      });
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.warning, i18n.getError(err), 'warning');
    })
    
  }

  startFreeTrial(params?:any) {
    let fd:any = params ? params : {};
    if(this.couponDetail) {
      fd.couponDetail = this.couponDetail;
    }
    fd.subscription_plan = this.planType;
    fd.plan_frequency = this.planFrequency;
    fd.free_trial = true;

    this.loaderService.startLoading();
    this.teemappService.changePlan(fd).subscribe((data:any) => {
      this.loaderService.stopLoading();
      let msg:string = '30 day free trial started';//i18n.t('setting.subscription_downgrade_submitted');
      Swal.fire(i18n.alert.done, msg, 'success').then(() => {
        this.onSubscribePlan.emit(data);
      });
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.warning, i18n.getError(err), 'warning');
    })
  }

}
